import React, { useEffect } from "react";
import MasterComponent from "../../../../components/Forms";
import { MasterConfigs } from "../../../../interfaces/entity";
import { FormInstance } from "antd";
import { EmployeeNumberConfig } from "../../../../entity/Organisations/Employees/Settings/EmployeeNumberConfig";

const AssetNumberSeries = () => {
    const [form, setForm] = React.useState<FormInstance>(null);
    const [previewNumber, setPreviewNumber] = React.useState({});

    function randomNumber(digits) {
        if (digits <= 0) {
            throw new Error("Number of digits must be greater than 0");
        }
        const min = Math.pow(10, digits - 1);
        const max = Math.pow(10, digits) - 1;
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    useEffect(() => {
        if (form) {
            let nextNumber;
            if (previewNumber['nextNumber']) {
                nextNumber = previewNumber['nextNumber'];
            } else {
                nextNumber = randomNumber(previewNumber['degits']);
            }
            form.setFieldsValue({ numberPreview: [previewNumber['prefix'], nextNumber, previewNumber['suffix']].filter(Boolean).join('-') });
        }
    }, [previewNumber]);


    const UpdateConfig: MasterConfigs = {
        ...EmployeeNumberConfig,
        api: () => '/assets-number-series',
        title: 'Asset Number Series',
        isActionTab: true,
        actions: [{ actionType: 'Add', name: 'Add Number Series' }],
        modalTitle: (action) => `${action} ${UpdateConfig.title}`,
        getFormColumns: () => {
            return EmployeeNumberConfig?.getFormColumns()?.map((column) => {
                if (['prefix', 'suffix',].includes(column.name)) {
                    return {
                        ...column,
                        inputProps: {
                            onChange: (e) => setPreviewNumber(prev => ({ ...prev, [column.name]: e.target.value })),
                        }
                    }
                } else if (column.name === 'degits') {
                    return {
                        ...column,
                        selectProps: {
                            onChange: (e) => setPreviewNumber(prev => ({ ...prev, [column.name]: e })),
                        }
                    }
                } else if (column.name === 'nextNumber') {
                    return {
                        ...column,
                        inputNumberProps: {
                            onChange: (e) => setPreviewNumber(prev => ({ ...prev, [column.name]: e })),
                        }
                    }
                }
                return column;
            })
        }
    }

    return (
        <MasterComponent config={UpdateConfig} form={(e) => setForm(e)} />
    );
}

export default AssetNumberSeries; 